export function formatInboxDate(date?: Date) {
  if (!date) {
    return `-`;
  }

  return new Date(date).toLocaleString();
}
